import { useEffect, useMemo, useState } from 'react';
import { DisplayableMenuItem } from '@/domain/product/types';
import useAnalytics from '@/dataAnalytics/hooks/useAnalytics';
import { useApplicationInitialized } from '@/hooks/useApplicationInitialized';
import {
  createItemAnalytics,
  onNonPizzaMenuPageLoad
} from '../categories/categories.analytics';
import { ItemAnalytics } from '@/dataAnalytics/analyticsTypes';

interface SortedSubcategory {
  products: DisplayableMenuItem[];
  heading: string;
}

export const useMenuPageAnalytics = (
  categoryDisplayName: string,
  loadingCategoryName: boolean,
  sortedSubcategories: SortedSubcategory[],
  sortedProducts: DisplayableMenuItem[],
  onPageLoad?: (items: ItemAnalytics[]) => void
): void => {
  const [pageLoadAnalyticsPushed, setPageLoadAnalyticsPushed] = useState<boolean>(false);
  const analytics = useAnalytics();
  const appInitialized = useApplicationInitialized();

  const categoryItemsForAnalytics = useMemo(() => {
    const subcategoryProducts: DisplayableMenuItem[] = sortedSubcategories
      .map(({ products, heading: subcategory }) => products.map((prod) => ({ ...prod, subcategory })))
      .flat();

    return createItemAnalytics(
      [...sortedProducts, ...subcategoryProducts],
      categoryDisplayName
    );
  }, [categoryDisplayName, sortedProducts, sortedSubcategories]);

  const categoryLocalizedItemsCount = categoryItemsForAnalytics.length;

  useEffect(() => {
    if (
      appInitialized
      && categoryLocalizedItemsCount
      && !loadingCategoryName
      && !pageLoadAnalyticsPushed
    ) {
      if (onPageLoad) {
        onPageLoad(categoryItemsForAnalytics);
      } else {
        analytics.push(() => onNonPizzaMenuPageLoad(categoryDisplayName, categoryItemsForAnalytics));
      }

      setPageLoadAnalyticsPushed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    categoryLocalizedItemsCount,
    loadingCategoryName,
    categoryDisplayName,
    pageLoadAnalyticsPushed,
    appInitialized
  ]);
};
